import { DuplicateTripCard } from './DuplicateTripCard';

import type { LegMatches } from './useDuplicateTripCheck';

type LegSpec = {
  timing: { date: string; pickup_time: string; is_will_call: boolean };
  label: string;
};

export function DuplicateTripsByLeg({
  legSpecs,
  legMatches,
}: {
  legSpecs: LegSpec[];
  legMatches: LegMatches[];
}) {
  return (
    <div className="flex flex-col gap-4">
      {legMatches
        .filter((lm) => lm.matches.length > 0)
        .map((lm) => {
          const spec = legSpecs[lm.legIndex];
          const heading = spec.timing.is_will_call
            ? `${spec.label} — ${spec.timing.date} (will-call)`
            : `${spec.label} — ${spec.timing.date} ${spec.timing.pickup_time}`;
          return (
            <section key={lm.legIndex} className="flex flex-col gap-2">
              <h4 className="text-sm font-semibold text-gray-700">{heading}</h4>
              <div className="flex flex-col gap-2">
                {lm.matches.map((trip) => (
                  <DuplicateTripCard key={trip.id} trip={trip} />
                ))}
              </div>
            </section>
          );
        })}
    </div>
  );
}
